import React from 'react'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import { BsQuestionCircle } from 'react-icons/bs'
import PropTypes from 'prop-types'

import AttributionList from './AttributionList'
import Tooltip from '../../../../../../components/Tooltip'

import { useShowAttributionWindows } from '../../../../../../pages/CampaignsSummary/CampaignsSummaryContent/LineItemsList/useShowAttributionWindows'

import { getCpaTitle } from './helpers'
import { getAttributions } from './AttributionList/helpers'
import { calculateCPA, getParsedResultsMetric } from '../helpers'
import { formatCurrency, formatNumber } from '../../../../../../helpers/numbers'
import { getSelectedPlatform } from '../../../../../../helpers/handlePlatformSelection'

import { campaignSelector } from '../../../../../../modules/selectors/campaigns'

import useStyles from '../../../styles'

const ConversionResultsCell = ({ componentData, currencySymbol, showAttributionWindow }) => {
  const classes = useStyles()

  const selectedPlatform = getSelectedPlatform()
  const { objective: campaignObjective } = useSelector(campaignSelector)

  const shouldShowAttributionWindows =
    useShowAttributionWindows(campaignObjective, selectedPlatform) && showAttributionWindow

  const { data, results } = componentData
  const originalSpendValue = data.spend

  const parsedResults = getParsedResultsMetric(results)
  const { name: resultsName, value } = parsedResults

  const calculatedCPA = calculateCPA(originalSpendValue, value)
  const cpaTitle = getCpaTitle(resultsName)

  return (
    <>
      <div
        className={classnames(classes.valueColumn, {
          [classes.valueColumnWithTooltip]: shouldShowAttributionWindows
        })}
      >
        {value ? formatNumber(value) : '-'}
        {shouldShowAttributionWindows && (
          <Tooltip
            className={classes.attributionsTooltip}
            triggerElement={<BsQuestionCircle className={classes.attributionTrigger} />}
            placement="top"
            bodyClassName={classes.attributionsTooltipBody}
          >
            <AttributionList attributions={getAttributions(parsedResults)} />
          </Tooltip>
        )}
      </div>
      {resultsName && <div className={classnames(classes.columnSubText, classes.resultName)}>{resultsName}</div>}

      {!!calculatedCPA && (
        <div className={classes.columnSubText}>
          {cpaTitle}:{' '}
          {formatCurrency(
            calculatedCPA,
            { min: 2, max: 2 },
            {
              symbol: currencySymbol
            }
          )}
        </div>
      )}
    </>
  )
}

ConversionResultsCell.propTypes = {
  componentData: PropTypes.object,
  currencySymbol: PropTypes.string,
  showAttributionWindow: PropTypes.bool
}
export default ConversionResultsCell
